import Axis from './Axis';

export default Axis;
